/* eslint-disable */

const defaultOptions = {
	timeout: 10000,
	jsonpCallback: 'callback',
	jsonpCallbackFunction: null,
};

const generateCallback = () => `jsonp_${Math.ceil(Math.random() * 100000)}`;

/* istanbul ignore next */
const clearCallback = (functionName) => {
	try {
		delete window[functionName];
	} catch (e) {
		window[functionName] = undefined;
	}
};

const generateScript = (scriptId, url) => {
	const script = document.createElement('script');
	script.setAttribute('id', scriptId);
	script.setAttribute('src', url);
	document.getElementsByTagName('head')[0].appendChild(script);
	return script;
};

const clearScript = scriptId => {
	const script = document.getElementById(scriptId);
	if (script) {
		document.getElementsByTagName('head')[0].removeChild(script);
	}
};

const fetchJsonp = (_url, options = {}) => {
	let url = _url + (_url.indexOf('?') > 0 ? '&' : '?');
	let timeoutId;
	const timeout = options.timeout || defaultOptions.timeout;
	const jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

	return new Promise((resolve, reject) => {
		const callbackFunction = options.jsonpCallbackFunction || generateCallback();
		const scriptId = `${jsonpCallback}_${callbackFunction}`;

		window[callbackFunction] = (response) => {
			resolve({
				ok: true,
				json: () => Promise.resolve(response),
			});

			clearTimeout(timeoutId);
			clearScript(scriptId);
			clearCallback(callbackFunction);
		};

		const script = generateScript(scriptId, `${url}${jsonpCallback}=${callbackFunction}`);

		timeoutId = setTimeout(() => {
			reject(new Error(`JSONP request to ${_url} timed out`));

			clearCallback(callbackFunction);
			clearScript(scriptId);

			/* istanbul ignore next */
			window[callbackFunction] = () => {
				clearCallback(callbackFunction);
			};
		}, timeout);

		script.onerror = () => {
			reject(new Error(`JSONP request to ${_url} failed`));

			clearCallback(callbackFunction);
			clearScript(scriptId);
			clearTimeout(timeoutId);
		};
	});
};

export default fetchJsonp;

/* eslint-enable */
